import { UrlMatchResult, UrlSegment } from '@angular/router';

const steps = new Set(['rooms', 'extras', 'checkout', 'confirmed', 'trip', 'trip-checkout', 'trip-confirmed']);
const localePattern = /^(en|fr|es|de|it|pt)(-[A-Za-z]{2})?$/;

// Supports partner-only and property links without mistaking a step for a locale.
export function partnerRouteMatcher(
  segments: UrlSegment[],
): UrlMatchResult | null {
  if (segments[0]?.path !== 'p' || !segments[1]?.path) return null;
  const posParams: Record<string, UrlSegment> = { partner: segments[1] };
  let count = 2;
  if (segments[count] && !steps.has(segments[count].path)) {
    if (!localePattern.test(segments[count].path))
      posParams['property'] = segments[count++];
    if (segments[count] && localePattern.test(segments[count].path))
      posParams['locale'] = segments[count++];
  }
  return { consumed: segments.slice(0, count), posParams };
}
